<img class="ctb-logo" [src]="state().src" [alt]="state().alt" width="360" height="260" />